export default "/public/img/GT-America-Bold.3e6c999b.otf";